export const SET_DEAL_TYPE = 'SET_DEAL_TYPE';
export function setDealType(dealType) {
  return {
    type: SET_DEAL_TYPE,
    dealType,
  };
}
